/* Public Stigg surface for Tokenwise. Picks the real SaaS service when a Stigg
 * client key is configured, else a no-op (local/dev/on-prem) — mirrors
 * studio-web's saas-vs-noop split. */

import { NoopStiggService } from "./noop-stigg.service";
import { SaasStiggService } from "./saas-stigg.service";
import { STIGG_ENABLED } from "./stigg.config";
import type { IStiggService } from "./stigg.types";

const stiggService: IStiggService = STIGG_ENABLED
  ? new SaasStiggService()
  : new NoopStiggService();

export const StiggProvider = stiggService.StiggProvider;
export const useTokenwisePlan = stiggService.useTokenwisePlan;
export const TokenwisePaywall = stiggService.Paywall;
export const TokenwiseCheckout = stiggService.Checkout;

export { STIGG_ENABLED } from "./stigg.config";
export type { TokenwisePlanState } from "./stigg.types";
